import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("rc_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("rc_token"))
      .finally(() => setLoading(false));
  }, []);

  const value = useMemo(() => {
    const login = async (email, password) => {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("rc_token", data.token);
      setUser(data.user);
      return data.user;
    };
    const signup = async (name, email, password) => {
      const { data } = await api.post("/auth/signup", { name, email, password });
      localStorage.setItem("rc_token", data.token);
      setUser(data.user);
      return data.user;
    };
    const logout = () => {
      localStorage.removeItem("rc_token");
      setUser(null);
    };
    return { user, loading, login, signup, logout };
  }, [user, loading]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
